import mapValues from 'lodash/fp/mapValues'
import range from 'lodash/range'
import toPairs from 'lodash/toPairs'
import Moment from 'moment'
import * as Form from '../../components/form'
import * as Types from './types'

interface StatusType {
  [key: string]: boolean,
  is_active?: boolean,
  is_subscribed?: boolean,
}

export const revertStatus = (status: StatusType): StatusType => {
  const newStatus = mapValues(status, (key: string) => !status[key])
  return newStatus
}

export const actionsFormat = (actions: Types.Actions) => {
  const newActions = {
    ...actions,
    last_week:  actions.last_week.map((action: Types.Action) => {
      action.created_at = Moment(action.created)
      action.issued_at = Moment(action.issue_date + ' GMT')
      return action
    }),
  }
  return newActions
}

const closestHour = (time: string) => {
  return time.split(':').length < 1 ?
         null :
         Number(time.split(':')[1]) < 30 ?
         Number(time.split(':')[0].slice(-2)) :
         Number(time.split(':')[0].slice(-2)) + 1
}

interface Day {
  [key: number]: number,
}

export const actionsByTime = (actions: string[]) => {
  const day: Day = {}
  actions.forEach((action: string) => {
    closestHour(Moment(action).format()) ?
    day[closestHour(Moment(action).format())] ?
    day[closestHour(Moment(action).format())] = day[closestHour(Moment(action).format())] + 1 :
    day[closestHour(Moment(action).format())] = 1
    :
    // tslint:disable-next-line: no-unused-expression
    null
  })
  const result: number[] = []
  for (const hour of range(25)) {
    day[hour] ? result.push(day[hour]) : result.push(0)
  }
  return result;
}

interface ProfileData {
  [key: string]: number
}
export const ProfileDataFormat = (data: ProfileData) =>
toPairs(data).map(([name, value]) => ({name, value}))

export const getMemberDetailSaveParams = (detail: Types.Member, form: Types.DetailsFormState): any => {
  return {
    id: detail.id,
    ...Form.modifiedFields(form),
  };
}

export const getMemberDetailFields =
  (member: Types.Member, attributes: Types.Attribute[]): Types.MemberDetailFormFields => {
    return {
      attributes,
      email: member.email,
      first_name: member.first_name,
      last_name: member.last_name,
      schedule_id: member.schedule_id,
    }
}

export const validate = (actions: Types.Action[]) => {
  return actions.filter((action) => action.action_type === 'click' ? action.title : action)
}

export const basicFormat = (member: Types.Member) => member



// WEBPACK FOOTER //
// ./src/pages/member-details/utils.ts